var Curriculog = Curriculog || {};

Curriculog.UserRolesFilter = (function ($, _, Backbone, UserRolesFilter) {

    UserRolesFilter = Curriculog.DropdownFilterView;

    return UserRolesFilter;

})($, _, Backbone, Curriculog.UserRolesFilter || {});